//Copied from antd/lib/date-picker/PickerButton.tsx
//修改button-size
import React from 'react';
import { Button } from '../button';
export default function PickerButton(props) {
    return React.createElement(Button, { size: 'xs', type: 'primary', ...props });
}
